export default "__VITE_ASSET__BV3CYNC5__"